var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 61.085,
    viewBox: "0 0 57 61.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(-215 -270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M139,36V3.294A3.365,3.365,0,0,1,142.294,0a3.217,3.217,0,0,1,3.294,3.294V36A3.3,3.3,0,1,1,139,36Z",
    transform: "translate(101.116 270)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M36.391,27.5A28.258,28.258,0,0,1,57,54.309c0,15.218-12.811,27.718-28.593,27.718C12.811,82.027,0,69.526,0,54.309A28.087,28.087,0,0,1,20.423,27.5c3.342-.906,4.827,3.986,1.485,4.891A23.016,23.016,0,0,0,5.2,54.309c0,12.5,10.4,22.645,23.208,22.645S51.8,66.809,51.8,54.309a23.016,23.016,0,0,0-16.71-21.921C31.749,31.482,33.235,26.591,36.391,27.5Z",
    transform: "translate(215 249.058)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffOn);
export default __webpack_public_path__ + "static/media/Off_On.bcf0934df53761e17064cd452e203334.svg";
export { ForwardRef as ReactComponent };